<template>
    <div>
        <div class="chat-message__message chat-message__bot-message summary-message">
            <p>Great choice! Here is your final configuration!</p>
            <ul>
                <li>{{ currentBodyStyle?.manufacturerName }} {{ currentBodyStyle?.derivativeName }} </li>
                <li>{{ currentBodyStyle?.fuelTypeName }} Engine</li>
                <li>{{ currentBodyStyle?.trimName }} Trim</li>
                <li v-if="colour && colour.toLowerCase() !== 'notsure'">{{ colour }} colour</li>
            </ul>
            <div class="chat-message__tail chat-message__tail--bot"></div>
        </div>
        <hr />
        <div class="submit-answers__container">
            <start-again :makeModelBot="true" />
            <next-button :makeModelBot="true" />
        </div>
    </div>
</template>

<script lang="ts">
import NextButtonComponent from '@/components/navigation/NextButtonComponent.vue';
import StartAgainComponent from '@/components/navigation/StartAgainComponent.vue';
import ExtraData from '@/models/ExtraData';
import Derivative from '@/models/vehicle/derivative';
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { namespace } from 'vuex-class';

const VehicleModule = namespace('vehicleModule');

@Component({
    components: {
        'next-button': NextButtonComponent,
        'start-again': StartAgainComponent
    }
})
export default class SubmitAnswersComponent extends Vue {
    public currentBodyStyle: Derivative | null = null;

    private colour = '';

    private toSentenceCase(colour: string): string {
        return colour.charAt(0).toUpperCase() + colour.slice(1);
    }

    mounted() {
        [this.currentBodyStyle] = this.$store.getters['vehicleSearchModule/derivatives'];
        
        const extraData: ExtraData = this.$store.getters['enquiryModule/extraData']
            .find((x: ExtraData) => x.keyName === 'basicColour');
        this.colour = this.toSentenceCase(extraData.keyValue);
    }
}
</script>
